/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.datepickers.init());


App.datepickers = {

  init() {
    this.build();

    return $(document)
      .off("click", ".js-datepicker-trigger", App.datepickers.triggered)
      .on("click", ".js-datepicker-trigger", App.datepickers.triggered);
  },


  build() {
    // Allow config via data- attrs, corresponding to the docs.
    // E.g.
    //   data-hidden-name="true" => { hiddenName: true }
    //
    $(".js-datepicker:not(.js-datepickered)").each(function() {
      const $this         = $(this);
      const format        = $this.data("format") || "mm/dd/yyyy";
      const format_submit = $this.data("format-submit") || "mm/dd/yyyy";
      const hidden_name   = $this.data("hidden-name") && ($this.data("hidden-name").toString() === "true");
      const editable      = $this.data("datepicker-editable");

      $this.pickadate({
        format,
        formatSubmit: format_submit,
        hiddenName: hidden_name,
        weekdaysShort: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        showMonthsShort: true,
        container: "body",
        editable
      });

      if (editable) {
        if (!window.datepicker_counter) { window.datepicker_counter = 0; }
        const num = window.datepicker_counter++;
        $this.attr("data-datepicker-id", num);
        const $trigger = $(`\
<div class='datepicker-trigger js-datepicker-trigger' data-for='${num}'></div>\
`);
        return $this.after($trigger);
      }
    });

    $(".js-timepicker:not(.js-timepickered)")
      .pickatime({
        editable: true,
        interval: 15,
        onOpen() {
          return window.setTimeout((() => document
            .querySelector('.picker__list-item--highlighted')
            .scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" })), 300);
        }
        })
      .on("click", function() {
        return $(this).pickatime("open");
    });

    $(".js-datepicker").addClass("js-datepickered");
    return $(".js-timepicker").addClass("js-timepickered");
  },

  triggered(evt) {
    evt.preventDefault();
    const $trigger = $(this);
    const $input = $(`[data-datepicker-id=${$trigger.data("for")}]`);
    return $input.pickadate("open");
  }
};
